import { PropsWithChildren, FC, } from 'react';

import styles from './Panel.module.scss';

const Panel: FC<PropsWithChildren> = ({ children }) => {
  return (
    <div className={styles.panel}>
      {children}
    </div>
  );
};

export default Panel;
